const C = "REPORT_ANALYTIC_CUSTOMER_PO";

export default {
    CHANGE_DATA_CHART: `${C}_CHANGE_DATA_CHART`,
    RESET_DATA: `${C}_RESET_DATA`,
    CHANGE_SEARCH_VALUE: `${C}_CHANGE_SEARCH_VALUE`,
}